import React, { useEffect, useState } from 'react';
import { useFormik, FieldArray, FormikProvider } from 'formik';
import { AddQuestionSchema } from './QuizManagementSchema';
import { FaPlus, FaTrash } from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux';
import { addUpdateQuestionRes, addUpdateQuestionTodo } from '../../LMS_Redux/LMS_Slices/Quiz/AddUpdateQuestion';
import { ToastContainer, toast } from 'react-toastify';
import { departmentListTodo } from '../../LMS_Redux/LMS_Slices/Assets/DepartmentList';
import Select from 'react-select'
import { uploadRes, uploadTodo } from '../../LMS_Redux/LMS_Slices/Assets/UploadImage';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';

export default function AddQuestion() {

    const { state } = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const departmentList = useSelector(state => state.depratmentList && state.depratmentList.data && state.depratmentList.data.data)
    const [spinner, setSpinner] = useState(false)
    // console.log(state)

    const userRole = JSON.parse(localStorage.getItem('user_data'));
    const role = userRole && userRole.vrole_name

    const instructor_dept = []
    if (role == "Instructor") {
        instructor_dept.push({
            "value": userRole.dept_id,
            "label": userRole.vdepartment_name
        })
    }
    const [selectedOptions, setSelectedOptions] = useState(state ? state?.department_data : role == "Instructor" ? instructor_dept : []);

    var options = []
    var options_data = []

    const dept_list = departmentList && departmentList?.filter(val => val?.vstatus == 'Active')?.map((value) => options.push({
        "value": value.did,
        "label": value.vdepartment_name
    }))

    const handleSelectChange = (selected) => {
        if (selected && selected?.length && selected[selected?.length - 1].value === 'select-all') {
            // "Select All" option was clicked
            if (selectedOptions?.length === options?.length) {
                setSelectedOptions([]);
            } else {
                setSelectedOptions(options);
            }
        } else {
            setSelectedOptions(selected || []);
        }
    };

    const customOptions = [{ value: 'select-all', label: 'Select All' }, ...options];

    if (state && state.option1 || state && state.image_option1) {
        options_data.push({
            opt: state.option1,
            file: state.image_option1,
        })
    }

    if (state && state.option2 || state && state.image_option2) {
        options_data.push({
            opt: state.option2,
            file: state.image_option2,
        })
    }

    if (state && state.option3 || state && state.image_option3) {
        options_data.push({
            opt: state.option3,
            file: state.image_option3,
        })
    }

    if (state && state.option4 || state && state.image_option4) {
        options_data.push({
            opt: state.option4,
            file: state.image_option4,
        })
    }

    if (state && state.option5 || state && state.image_option5) {
        options_data.push({
            opt: state.option5,
            file: state.image_option5,
        })
    }

    const initialValues = {
        department: selectedOptions || [],
        remark: state ? state.remark : '',
        status: state ? state.status : '',
        question: state ? state.question : '',
        right: state ? state.correct_ans : '',
        options: state ? options_data :
            [
                {
                    opt: "",
                    file: "",
                },
                {
                    opt: "",
                    file: "",
                }
            ],
        question_id: state ? state.id : ''
    };

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: AddQuestionSchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            // console.log("new", values)
            setSpinner(true)
            dispatch(addUpdateQuestionTodo(values)).then(() => add_update_res())

            var file_reset = document.querySelectorAll('.file')
            for (var i = 0; i < file_reset.length; i++) {
                file_reset[i].value = '';
            }
        },
    })

    const add_update_res = () => {
        // console.log(addUpdateQuizRes)
        if (addUpdateQuestionRes && addUpdateQuestionRes.success) {
            toast.success(addUpdateQuestionRes.message, { position: "bottom-right" })
            setSpinner(false)
            setSelectedOptions([])
            setTimeout(() => {
                navigate('/question_list')
            }, 2000);

        } else {
            setSpinner(false)
            toast.error(addUpdateQuestionRes.message, { position: "bottom-right" })
        }
    }

    const uploads = (file, index) => {

        if (file) {
            dispatch(uploadTodo(file)).then(() => upload_res(index))
        }
    }

    const upload_res = (index) => {
        // console.log(uploadRes)
        if (uploadRes && uploadRes.success) {
            formik.setFieldValue(index, uploadRes.data.path)
            toast.success(uploadRes.message, { position: "bottom-right" })
        } else {
            toast.error(uploadRes.message, { position: "bottom-right" })
        }
    }

    useEffect(() => {
        dispatch(departmentListTodo())
    }, [])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Quiz Management /</span>
                    {state ?
                        <Link to={"/question_list"}><span className='icon2'>Question List / </span></Link>
                        : ''
                    }
                    <span className='icon2'>{state ? "Edit" : "Add"} Question</span>
                </div>
                <div className='wrapper-admin'>
                    <FormikProvider value={formik}>
                        <form onSubmit={(e) => { e.preventDefault(); formik.handleSubmit(); }}>
                            <div className="row">

                                {role !== "Instructor" ?
                                    <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Permission Granted To</label>
                                            <Select
                                                closeMenuOnSelect={false}
                                                // defaultValue={state ? state.department_data : role == "Instructor" ? instructor_dept : ''}
                                                onBlur={formik.handleBlur}
                                                name='department'
                                                isMulti
                                                placeholder="Select Permission To"
                                                classNamePrefix="select"
                                                isDisabled={role === "Instructor" ? true : false}
                                                options={customOptions}
                                                value={formik.values.department}
                                                onChange={handleSelectChange}
                                                hideSelectedOptions={true}
                                                allowSelectAll={true}
                                            />
                                            {formik.errors.department && formik.touched.department ? (<span className='text-danger form_label'>{formik.errors.department}</span>) : null}
                                        </div>
                                    </div>
                                    : ''
                                }

                                {/* <div className="col-12 col-md-4">
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label form_label">Type</label>
                                        <select className="form-select form_input"
                                            name='type' value={formik.values.type || ''} onChange={formik.handleChange} onBlur={formik.handleBlur}
                                        >
                                            <option value="">Select</option>
                                            <option value="Beginner">Beginner</option>
                                            <option value="Intermediate">Intermediate</option>
                                            <option value="High Level">High Level</option>
                                        </select>
                                        {formik.errors.type && formik.touched.type ? (<span className='text-danger form_label'>{formik.errors.type}</span>) : null}
                                    </div>
                                </div> */}

                                <div className="col-12 col-md-4">
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label form_label">Status</label>
                                        <select className="form-select form_input"
                                            name='status' value={formik.values.status || ''} onChange={formik.handleChange} onBlur={formik.handleBlur}
                                        >
                                            <option value="">Select</option>
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                        {formik.errors.status && formik.touched.status ? (<span className='text-danger form_label'>{formik.errors.status}</span>) : null}
                                    </div>
                                </div>

                                <div className="col-12 col-md-4">
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label form_label">Remark</label>
                                        <textarea className="form_input form-control" placeholder="Remark" rows={1}
                                            name='remark' value={formik.values.remark || ''} onChange={formik.handleChange} onBlur={formik.handleBlur}
                                        />
                                        {formik.errors.remark && formik.touched.remark ? (<span className='text-danger form_label'>{formik.errors.remark}</span>) : null}
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label form_label">Question Text</label>
                                        <textarea className="form_input form-control" placeholder="Question Text"
                                            name='question' value={formik.values.question || ''} onChange={formik.handleChange} onBlur={formik.handleBlur}
                                        />
                                        {formik.errors.question && formik.touched.question ? (<span className='text-danger form_label'>{formik.errors.question}</span>) : null}
                                    </div>
                                </div>

                                <div className='col-md-12 '>
                                    {/* <div className='circle'><IoOptionsSharp  /></div> */}
                                    <h6>Options</h6>
                                    <hr />
                                </div>

                                <FieldArray
                                    name="options"
                                    render={(arrayHelpers) => (
                                        <>
                                            <div className="col-md-12">
                                                <div className='float-end'>
                                                    <button type='button' className='btn add_btn me-2' onClick={() => arrayHelpers.push({ opt: "", file: "" })}>
                                                        <FaPlus size={18} />
                                                    </button>
                                                </div>
                                            </div>


                                            {formik.values.options.map((field, index) => (

                                                <div className="col-12 col-md-3" key={index}>
                                                    <div className="mb-3">
                                                        <label htmlFor="" className="form-label form_label">Option {String.fromCharCode(65 + index)}</label>
                                                        {(index !== 0) && (index !== 1) ?
                                                            <span className='float-end' onClick={() => arrayHelpers.remove(index)}>
                                                                <FaTrash size={18} style={{ color: '#DC3545', cursor: 'pointer' }} />
                                                            </span>
                                                            : ''
                                                        }
                                                        <input type="text" className="form_input form-control" placeholder={"Option" + ' ' + String.fromCharCode(65 + index)}
                                                            name={`options[${index}].opt`}
                                                            value={formik.values.options[index].opt}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        />

                                                        <input className="form-control form_input file mt-1" type="file"
                                                            name={`options[${index}].file`}
                                                            onChange={(e) => uploads(e.currentTarget.files[0], `options[${index}].file`)}
                                                            // onChange={(e) => formik.setFieldValue(`options[${index}].file`, e.currentTarget.files[0])}
                                                            onBlur={formik.handleBlur}
                                                        />

                                                        {formik.touched.options && formik.touched.options[index] && formik.touched.options[index].file && formik.errors.options && formik.errors.options[index] && formik.errors.options[index].file ?
                                                            (<span className='text-danger form_label'> {formik.errors.options[index].file}</span>) : null
                                                        }
                                                    </div>
                                                </div>

                                            ))}
                                        </>
                                    )}
                                />

                                <div className="row">
                                    <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="option" className="form-label form_label">Correct Answer</label>
                                            <select className="form-select form_input"
                                                name='right' value={formik.values.right || ''} onChange={formik.handleChange} onBlur={formik.handleBlur}
                                            >
                                                <option value="">Select</option>
                                                {formik.values.options.map((field, index) => (
                                                    <option value={String.fromCharCode(65 + index)} key={index}>Option {String.fromCharCode(65 + index)}</option>
                                                ))}
                                            </select>
                                            {formik.errors.right && formik.touched.right ? (<span className='text-danger form_label'>{formik.errors.right}</span>) : null}
                                        </div>
                                    </div>
                                </div>

                                <div className='text-end'>
                                    <button className='btn btn_submit' type='submit' disabled={spinner ? true : false}>Submit
                                        {spinner ?
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                className='ms-2'
                                            />
                                            : ''
                                        }
                                    </button>
                                </div>
                            </div>
                        </form>
                    </FormikProvider>
                </div>
            </div>
            <ToastContainer />
        </>
    )
}